<template>
    <div class="warehouse_add_wrap">
        <div class="warehouse_add_top">
            <div class="warehouse_add_code_identification">
                <div><span v-if="related_info && related_info.related_num">业务编号：<span class="template_color" @click="handleClickRelatedDetail" v-text="related_info.related_num"></span></span></div>
                <el-button v-if="!pending_info || pending_info.biz_type != 'order'"  size="small" type="primary" @click="handleClickCodeIdentification">编码识别</el-button>
            </div>

            <div class="warehouse_add_table mb_16">
                <el-table class="custom_table" :data="formData.productData" border  ref="table" :span-method="arraySpanMethod">
                    <el-table-column v-if="pending_info && pending_info.related_type == 'order'" label="售卖产品" prop="goods_name" show-overflow-tooltip  min-width="220px">
                        <template slot-scope="{row}">
                            <div v-if="row.goods_info" class="bundle_wrap">
                                <div v-if="row.goods_info.goods_type == 'bundle'">
                                    <h5  v-text="row.goods_info.goods_name"></h5>
                                    <p   v-for="child in row.goods_info._child" v-text="child.goods_name"></p>
                                </div>
                                <div v-else v-text="row.goods_info.goods_name"></div>
                            </div>

                        </template>
                    </el-table-column>
                    <el-table-column label="产品名称" prop="name" show-overflow-tooltip   min-width="434px"></el-table-column>
                    <el-table-column label="待出库数量" prop="audit_num" show-overflow-tooltip  width="100px" ></el-table-column>
                    <el-table-column label="单位" prop="unit" show-overflow-tooltip  width="80px" ></el-table-column>
                    <el-table-column class-name="tableInputColumn" label="出库仓库" prop="stock_id"   width="226px">
                        <template #header>
                            <span style="margin-right: 4px">出库仓库</span>
                            <el-popover placement="bottom" ref="stockPopover">
                                <span slot="reference">
                                    <el-tooltip class="item" content="批量出库" effect="dark" placement="top">
                                        <span class="handle_icon_wrap"><i class="iconfont icon-a-tianjiamiaobian"></i></span>
                                    </el-tooltip>
                                </span>
                                <el-select  v-model="stock_id"  class="tableInput" filterable  placeholder="请选择出库仓库"    remote reserve-keyword >
                                    <el-option v-for="item in stockList" :key="item.id" :label="item.name" :value="item.id" @click.native="handleChangeProductStockAll(item)"> </el-option>
                                </el-select>
                            </el-popover>
                        </template>
                        <template slot-scope="{row}">
                            <el-select v-model="row.stock_id"  @focus="handleFocusStock(row)" clearable  filterable  placeholder="请选择出库仓库" remote reserve-keyword @clear="handleClickClearStock(row)">
                                <el-option v-for="item in row.stock_list" :key="item.id" :label="item.name" :value="item.id" @click.native="handleClickProductStock(item,row)"> </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="库存数量" prop="stock_num" show-overflow-tooltip  width="90px" >
                        <template slot-scope="{row}">
                           <span v-text="(row.stock_info && row.stock_info.total_num) ? row.stock_info.total_num :0"></span>
                        </template>
                    </el-table-column>
                    <el-table-column label="出库数量/产品编码" prop="id" min-width="332px"  class-name="tableInputColumn">
                        <template slot-scope="{row,$index}">
                            <div class="product_num_code">
                                <el-input v-model="row.no_code_num" :disabled="row.stock_info.no_code_num > 0 ? false :true" placeholder="请输入数量" type="mini" @change="handleChangeNum(row,$index)"></el-input>
                                <div class="line"></div>
                                <div class="change_code">
                                    <el-popover  placement="bottom"  popper-class="product_code_popper" title=""  width="226"  trigger="hover">
                                            <span class="change_code_wrap" slot="reference" @click="handleClickSelectCode(row)">
                                               <i class="el-icon-circle-plus-outline"></i>
                                               <span>选择编码</span>
                                            </span>
                                        <div class="product_code_wrap">
                                            <ul>
                                                <li v-for="item in row.code_list" class="ellipsis" v-text="item.code"></li>
                                            </ul>
                                            <div class="code_num_wrap">
                                                共：{{ row.code_list.length}}条
                                            </div>
                                        </div>
                                    </el-popover>
                                </div>
                                <div class="total_num">
                                    共<span v-if="row.total_num" v-text="row.total_num"></span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>

                </el-table>

            </div>

            <div class="warehouse_add_from">
                <el-form ref="formData"  :model="formData"  :rules="formDataRules"  label-position="top"  size="small">
                    <el-form-item label="附件" class="label-bold" prop="file_list">
                        <div class="file_upload_wrap">
                            <div v-if="formData.file_list.length===0" class="file_outer_wrap">
                                <img alt=""  src="https://download.hecoos.com/enlightv/2023-31/3wy8ZnscPAjXMD2XmQhb.png"  width="36">
                                <p class="file_hint">点击或者将文件拖拽到这里上传</p>
                                <p class="file_type_hint">支持.rar .zip .doc .docx .pdf .jpg...</p>
                                <input class="upload_input"  multiple type="file" @change="handleUploadFileChange($event)">
                            </div>
                            <ul v-else class="upload_file_list">
                                <li v-for="file in formData.file_list" class="upload_file_item">
                                    <div class="file_left_wrap">
                                        <img alt="" class="file_img"  src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png">
                                        <div class="file_info_wrap">
                                            <p class="file_name" v-text="file.file_name"></p>
                                            <p class="file_size" v-text="file.file_size"></p>
                                        </div>
                                    </div>
                                    <div class="file_right_wrap">
                                        <el-tooltip content="预览"  effect="dark"  placement="top">
                                            <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                <i class="iconfont icon-yanjing"></i>
                                            </span>
                                        </el-tooltip>
                                        <span class="line"></span>
                                        <el-tooltip content="删除"  effect="dark"  placement="top">
                                            <span class="handle_icon_wrap handle_icon_danger_wrap"  @click="formData.file_list.splice(file_idx,1)">
                                                <i class="iconfont icon-shanchu1"></i>
                                            </span>
                                        </el-tooltip>
                                    </div>
                                </li>
                                <li class="upload_file_btn_wrap">
                                    <i class="el-icon-plus"></i>
                                    <span>添加附件</span>
                                    <input class="upload_input"  multiple  type="file"  @change="handleUploadFileChange($event)">
                                </li>
                            </ul>
                        </div>
                    </el-form-item>
                    <el-form-item label="备注信息" class="label-bold" prop="note">
                        <el-input type="textarea" :rows="5" v-model="formData.note" placeholder="请输入备注信息"></el-input>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="warehouse_add_bottom">
            <el-button size="small" @click="handleClickClose">取消</el-button>
            <el-button :disabled="btnDisabled" size="small" type="primary" @click="handleClickConfirm">提交</el-button>
        </div>
        <CodeIdentification :codeIdentificationDialog.sync="codeIdentificationDialog" v-if="codeIdentificationDialog" :sourceType="'out'"   :related_info="related_info" :productInfo="productInfo" :selectedCodeData="selectedCodeData" @success="identificationCodeSuccess" />

        <SelectCode v-if="selectCodeDialog" :productInfo="productInfo" :selectCodeDialog.sync="selectCodeDialog" :relatedId="related_info.related_id" :stockType="pending_info.stock_type" :maxChangeNum="maxChangeNum"  :selectedCodeData="selectedCodeData" @success="selectCodeSuccess"></SelectCode>
        <PurchaseDetail v-if="purchaseDetailVisible" :purchaseDetailVisible.sync="purchaseDetailVisible" :purchaseId="related_info.related_id"/>
        <el-image :preview-src-list="previewImgList" :src="previewImgSrc" ref="preview_img" style="display: none"></el-image>
    </div>
</template>
<script>
import {stockList,chooseCode,pendingOutDetail,pendingOut,codeOutGetProduct,getStocksByProduct,getStocksAuth} from "@/api/index.js"
import {formatFileSize,removeTag} from "@/utils";
import {getOSSData, uploadImg} from "@/utils/uploadOss";
import SelectProductOut from  "../component/select_product_out"
import CodeIdentification from  "../component/code_identification"
import SelectCode from  "../component/select_code"
import PurchaseDetail from "../../Purchase/component/purchase_detail"; //采购详情
import {EventBus} from '@/utils/eventBus';
export default {
    name: 'OutWarehouseAudit',
    components: {
        SelectProductOut,
        CodeIdentification,
        SelectCode,
        PurchaseDetail
    },
    data() {
        return {
            btnDisabled:false,
            formData:{
                productData:[],
                file_list:[],
                note:''
            },
            formDataRules:{},
            stock_id:'',
            stockList:[],
            codeIdentificationDialog:false, //选择编码/编码识别
            productInfo:null,//选中的产品
            selectedCodeData:[],
            selectProductOutDialog:false,//选择入库产品

            selectCodeDialog:false,
            stock_pending_id:0,
            related_info:null,
            pending_info:null,
            purchaseDetailVisible:false,
            maxChangeNum:0,//最多可选编码
            previewImgList: [],
            previewImgSrc: "",
        }
    },

    mounted() {

    },
    created() {
        this.getStockList()
        this.stock_pending_id = this.$route.query.stock_pending_id
        this.getPendingOutDetail()
    },
    methods: {
        // 获取仓库
        getStockList(){
            stockList({}).then(res => {
                if (res.code === 200) {
                    this.stockList = res.data
                }
            })
        },
        // 根据产品获取仓库
        handleFocusStock(row){
            if(row.name){
                let postData  = {
                    product_name:row.name,
                    sku_id:row.sku_id,
                    sku_key:row.sku_key,
                }
                getStocksByProduct(postData).then(res => {
                    if (res.code === 200) {
                        let data = res.data ? res.data.map((item)=>{
                            return {
                                id:item.stock_id,
                                name:item.stocks.name,
                                code_num:item.code_num,
                                no_code_num:item.no_code_num,
                                total_num:item.total_num,
                            }
                        }) : []
                        this.$set(row,'stock_list',data)
                    }
                })
            }
        },
        // 获取详情
        getPendingOutDetail(){
            pendingOutDetail({ stock_pending_id:this.stock_pending_id }).then(res => {
                if (res.code === 200) {
                    let {related_info,product_list,pending_info,goods_list} = res.data
                    this.related_info = related_info
                    this.related_info.stock_pending_id = this.stock_pending_id
                    goods_list.forEach(item => {
                        item.goodsChildIds = []
                        if(item._child){
                            item.goodsChildIds = item._child.map(child => child.order_goods_id)
                        }
                        item.goodsChildIds.push(item.order_goods_id)
                    })

                    let productData = product_list.map(item => {
                        let goods_info = null
                        if(pending_info.biz_type == 'order'){
                           goods_info = goods_list.find(find => find.goodsChildIds.indexOf(item.related_detail_id) > -1)
                            let goods_id = item.related_detail_id == goods_info.order_goods_id ? goods_info.goods_id : goods_info._child.find(child => child.order_goods_id == item.related_detail_id).goods_id
                            let goods_sku_id = item.related_detail_id == goods_info.order_goods_id ? goods_info.goods_sku_id : goods_info._child.find(child => child.order_goods_id == item.related_detail_id).goods_sku_id
                            return {
                                goods_id,
                                goods_sku_id,
                                goods_info:goods_info,
                                name:item.product_name,
                                stock_pending_product_id:item.stock_pending_product_id,
                                related_type:item.related_type,
                                related_id:item.related_id,
                                related_detail_id:item.related_detail_id,
                                sku_id:item.sku_id,
                                sku_key:item.sku_key,
                                unit:item.unit,
                                stock_id:'',
                                audit_num:item.num,//待出库数量
                                audit_no_code_num:item.no_code_num,//可选的无编码数量
                                audit_code_num:item.code_num,//可选的有编码数量
                                no_code_num:'', //输入的无编码数量
                                code_num:0, //选择的有编码数量
                                code_list:[], //选择的编码
                                total_num:0, //选择的总数量
                                stock_list:[],
                                stock_info:{}
                            }
                        }else{
                            return {
                                name:item.product_name,
                                stock_pending_product_id:item.stock_pending_product_id,
                                related_type:item.related_type,
                                related_id:item.related_id,
                                related_detail_id:item.related_detail_id,
                                sku_id:item.sku_id,
                                sku_key:item.sku_key,
                                unit:item.unit,
                                stock_id:'',
                                audit_num:item.num,//待出库数量
                                audit_no_code_num:item.no_code_num,//可选的无编码数量
                                audit_code_num:item.code_num,//可选的有编码数量
                                no_code_num:'', //输入的无编码数量
                                code_num:0, //选择的有编码数量
                                code_list:[], //选择的编码
                                total_num:0, //选择的总数量
                                stock_list:[],
                                stock_info:{}
                            }
                        }
                    })
                    if(pending_info.biz_type == 'order') {
                        productData.sort((a, b) => {
                            return a.goods_id - b.goods_id; // 升序排序
                        });
                    }
                    this.formData.productData = productData

                    this.pending_info = pending_info

                }
            })
        },
        arraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if(this.pending_info.biz_type == 'order'){
                if (columnIndex === 0) {
                    const currentId = row.goods_info.order_goods_id;
                    const prevId = rowIndex > 0 ? this.formData.productData[rowIndex - 1].goods_info.order_goods_id : null;
                    const nextId = rowIndex < this.formData.productData.length - 1 ? this.formData.productData[rowIndex + 1].goods_info.order_goods_id : null;
                    // 如果当前行的 ID 和上一行的 ID 不同，则合并
                    if (currentId !== prevId) {
                        // 统计当前 ID 连续出现的次数
                        let spanCount = 1;
                        for (let i = rowIndex + 1; i < this.formData.productData.length; i++) {
                            if (this.formData.productData[i].goods_info.order_goods_id === currentId) {
                                spanCount++;
                            } else {
                                break;
                            }
                        }
                        return [spanCount, 1]; // 合并行数
                    } else {
                        return [0, 0]; // 不显示单元格
                    }
                }
            }
        },
        // 编码识别
        handleClickCodeIdentification(){
            this.productInfo = null
            this.selectedCodeData = []
            this.formData.productData.forEach(item =>{
                this.selectedCodeData = this.selectedCodeData.concat(item.code_list)
            })
            this.codeIdentificationDialog = true
        },
        identificationCodeSuccess(data){
            this.loading = true
            let code_list = []
            this.formData.productData.forEach((item, key) => {
                let code = item.code_list.map(map => map.code)
                code_list = [...code_list, ...code]
            })
            let codeList = data.code_list.filter(item => !code_list.includes(item));
            if(codeList.length != data.code_list.length){
                this.$message.error('检查到有重复的编码已经为您去重')
            }
            if(codeList.length == 0){
                this.loading = false;
                return  false
            }

            codeOutGetProduct({code_list:codeList}).then(res => {
                if (res.code === 200) {
                    let {data} = res
                    data.forEach((item,key)=>{
                        this.mergeProductFunction(item)
                    })
                }
                this.loading = false
            })
        },
        mergeProductFunction(row){
            let flag = true
            if(this.formData.productData.length>0){
                this.formData.productData.forEach((item, index) => {
                    if(item.name == row.name && item.sku_id == row.sku_id && item.sku_key == row.sku_key){
                        if(item.stock_id == row.stock_id){
                            let code_list = row.code_list.map((map)=>{return {code:map}})
                            this.$set(item,'code_list',item.code_list.concat(code_list))
                            this.$set(item,'code_num',item.code_list.length)
                            this.$set(item,'total_num',Number(item.code_num) + Number(item.no_code_num))
                        }else if(item.stock_id == ''){
                            this.$set(item,'stock_list',row.stocks ? row.stocks : [])
                            if(item.stock_list.find(find => find.id == row.stock_id)){
                                this.$set(item,'stock_id',row.stock_id)
                                this.$set(item,'stock_info',item.stock_list.find(find => find.id == row.stock_id))
                                let code_list = row.code_list.map((map)=>{return {code:map}})
                                this.$set(item,'code_list',item.code_list.concat(code_list))
                                this.$set(item,'code_num',item.code_list.length)
                                this.$set(item,'total_num',Number(item.code_num) + Number(item.no_code_num))
                            }
                        }
                    }
                })
            }

        },

        // 输入数量
        handleChangeNum(row,index){
            const num = row.no_code_num;
            const regex = /^[1-9]\d*$/; // 正整数的正则表达式
            if (!regex.test(num) || !row.stock_id) {
                this.$set(row,'no_code_num',0)
            } else {
                // // 如果输入的数量大于  待办总数量 - 有编码的数量
                if(row.no_code_num > row.audit_num - row.code_num){
                    this.$set(row,'no_code_num',row.audit_num - row.code_num)
                }

                // 如果是采购退货 （采购入库过）则出库时得选择当时入过的，，
                if(this.pending_info.stock_type == 'purchase_return'){
                    // 如果输入的数量大于  当时入库时的无编码数量（待办无编码数量）
                    if(row.no_code_num >  row.audit_no_code_num){
                        let remaining =  row.no_code_num  - row.audit_no_code_num // 多余的数量
                        // 如果多余的数量大于 当时入库时的有编码数量 则取当时入库时的有编码数量  否则取多余的数量
                        remaining = remaining > row.audit_code_num ? row.audit_code_num : remaining
                        this.$set(row,'no_code_num',row.audit_no_code_num)
                        this.automatic_replenishment(row,remaining) //自动补充编码
                    }
                }else{

                    // 获取相同的产品
                   let identicalData = this.formData.productData.filter((filter,filterIndex) => filter.name == row.name && filter.sku_id == row.sku_id && filter.sku_key == row.sku_key && filter.stock_id == row.stock_id && filterIndex != index)
                    // 相同产品已使用的无编码总和（不包含自己）
                    const use_no_code_num = identicalData.map(item => item.no_code_num).reduce((a, b) => a + b, 0);
                    // 相同产品已使用的有编码总和（不包含自己）
                    const use_code_num = identicalData.map(item => item.code_num).reduce((a, b) => a + b, 0);
                    // 库存中还可以选择的无编码数量
                    let stock_no_code_num = row.stock_info.no_code_num - use_no_code_num
                    // 库存中还可以选择的有编码数量
                    let stock_code_num = row.stock_info.code_num - use_code_num

                    // 如果输入的无编码数量  大于 库存的无编码数量
                    if(row.no_code_num >  stock_no_code_num){
                        // 输入的无编码数量 -  库存的无编码数量 == 多余的数量
                        let remaining =  row.no_code_num  - stock_no_code_num
                        //如果多余的数量大于库存编码数量则自动补充的数量等于编码数量否则自动补充多余的数量
                        remaining = remaining > stock_code_num ? stock_code_num : remaining
                        this.automatic_replenishment(row,remaining) //自动补充编码
                        this.$set(row,'no_code_num',stock_no_code_num)
                    }
                }
            }
            this.$set(row,'total_num',Number(row.code_num) + Number(row.no_code_num))
        },
        // 自动补充编码
        automatic_replenishment(row,remaining){

            // 相同的产品
            let identicalData = this.formData.productData.filter((filter) => filter.name == row.name && filter.sku_id == row.sku_id && filter.sku_key == row.sku_key && filter.stock_id == row.stock_id)
            let identicalProductCodeList =  []
            identicalData.forEach((item)=>{
                identicalProductCodeList = identicalProductCodeList.concat(item.code_list)
            }) //获取所有的相同产品已使用的编码
            let postData = {
                page: 1,
                pageSize: remaining + identicalProductCodeList.length, // 需要自动选择的编码+已经选择了的编码
                product_name:row.name,
                sku_id:row.sku_id,
                stock_id:row.stock_id,
                keyword: ''
            }
            chooseCode(postData).then(res => {
                if (res.code === 200) {
                    let {list, total} = res.data
                    // 创建一个包含 code 中现有的集合以便快速查找
                    const existingCodes = new Set(identicalProductCodeList.map(item => item.code));
                    // 过滤 list，获取不在 identicalProductCodeList 中的值 并且状态是正常的编码
                    const filteredList = list.filter(item => !existingCodes.has(item.code) && item.status == 0);
                    // 从过滤后的列表中添加 'remaining' 个到 code_list中
                    row.code_list.push(...filteredList.slice(0, remaining));
                    this.$set(row,'code_num',row.code_list.length)
                    this.$set(row,'total_num',Number(row.code_num) + Number(row.no_code_num))
                    const h = this.$createElement;
                    this.$msgbox({
                        title: '库存数量已自动补充',
                        message: h('div', null, [
                            h('span', null, '此产品无编码数量不足，已为您使用无编码与有编码组合，系统将自动选择有编码产品！'),
                        ]),
                        iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                        customClass: 'prompt_message_custom',
                        confirmButtonText:  '知道了' ,
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                        showCancelButton: false,
                        confirmButtonClass: 'el-button--primary',
                        beforeClose: (action, instance, done) => {
                            if (action === 'confirm') {
                                done();
                            } else {
                                done();
                            }
                        }
                    }).then(() => {

                    }).catch(() => {

                    })
                }else{

                }
            })
        },
        // 选择产品编码
        handleClickSelectCode(row){
            if(!row.name){ return this.$message.error('请先选择产品')}
            if(!row.stock_id){return this.$message.error('请先选择出库仓库')}
            this.productInfo = row
            this.selectedCodeData = []
            this.formData.productData.forEach(item =>{
                // 除了当前产品外其他已选的编码
                if(item.stock_pending_product_id != row.stock_pending_product_id){
                    this.selectedCodeData = this.selectedCodeData.concat(item.code_list)
                }
            })
            this.maxChangeNum = row.audit_num - row.no_code_num
            if(this.maxChangeNum == 0){
                return this.$message.error('出库数量不可大于待出库数量')
            }
            this.selectCodeDialog = true
        },
        // 选择编码后回调
        selectCodeSuccess(data){
            this.$set(this.productInfo,'code_list',data)
            this.$set(this.productInfo,'code_num',this.productInfo.code_list.length)
            this.$set(this.productInfo,'total_num',Number(this.productInfo.code_num) + Number(this.productInfo.no_code_num))
        },
        // 批量选择仓库
        handleChangeProductStockAll(item){
            let postData = {
                stock_id:item.id,
                product_list:this.formData.productData.map((map)=>{
                    return {
                        product_name:map.name,
                        sku_id:map.sku_id,
                        sku_key:map.sku_key,
                    }
                })
            }
            getStocksAuth(postData).then(res => {
                if (res.code === 200) {
                    let dataInfo = res.data
                    this.formData.productData.forEach(list => {
                        let productItem = dataInfo.find(find => find.product_name == list.name && find.sku_id == list.sku_id && find.sku_key == list.sku_key && find.total_num > 0)
                        let stock_auth = productItem?.stock_auth
                        if(stock_auth){
                            this. this.handleClickClearStock(list)
                            let stock_info = {
                                id:item.id,
                                name:item.name,
                                no_code_num:productItem.no_code_num,
                                code_num:productItem.code_num,
                                total_num:productItem.total_num,
                            }

                            this.$set(list,'stock_info',stock_info)
                            this.$set(list,'stock_id',stock_info.id)
                            this.$set(list,'stock_name',stock_info.name)
                            this.$set(list,'stock_list',[
                                stock_info
                            ])
                        }
                    })
                }
            })


            this.$forceUpdate()
            this.$refs.stockPopover.doClose()
        },
        // 选择单个仓库
        handleClickProductStock(item,row) {
            this.handleClickClearStock(row)
            if(row.name){
                let stock_info = row.stock_list.find(find => find.id == item.id)
                if(stock_info){
                    this.$set(row,'stock_info',stock_info)
                }
            }
        },
        // 清空仓库
        handleClickClearStock(row){
            this.$set(row,'code_num',0)
            this.$set(row,'code_list',[])
            this.$set(row,'no_code_num',0)
            this.$set(row,'total_num',0)
            this.$set(row,'stock_info',{code_num:0,no_code_num:0,total_num:0})
        },
        // 上传附件
        handleUploadFileChange(e){
            const files = e.target.files
            const that = this;
            Array.from(files).forEach(file => {
                uploadImg(file, 50).then(res => {
                    if (res.file_path) {
                        res.file_size = formatFileSize(file.size)
                        this.formData.file_list.push(res)
                        e.target.value = ''
                    }
                    e.target.value = ''
                }).catch(error => {
                    e.target.value = ''
                })
            })
        },
        // 预览
        handleClickPreview(file){
            if (file.file_type.indexOf("image") > -1) {
                this.previewImgList = [file.file_path];
                this.previewImgSrc = file.file_path;
                this.$refs.preview_img.showViewer = true;
            } else {
                if (file.file_type.indexOf("pdf") > -1) {
                    window.open(file.file_path);
                } else {
                    this.$message.error("当前文件格式不支持预览，请下载后查看");
                }
            }
        },
        handleClickClose(){
            if (this.formData.note || this.formData.file_list.length > 0 || this.formData.productData.filter(item => (item.stock_id || item.total_num )).length>0 ){
                const h = this.$createElement;
                this.$msgbox({
                    title: '取消',
                    message: h('div', null, [
                        h('span', null, '取消后，编辑内容不保留，是否取消！'),
                    ]),
                    iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                    customClass: 'prompt_message_custom',
                    confirmButtonText:  '确定',
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    showCancelButton: true,
                    confirmButtonClass:  'el-button--primary',
                    beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                            done();
                        } else {
                            done();
                        }
                    }
                }).then(() => {
                    removeTag(this.$route)
                    this.$router.go(-1);
                }).catch(() => {
                })
            }else{
                removeTag(this.$route)
                this.$router.go(-1);
            }
        },
        handleClickConfirm(){
            this.$refs.formData.validate((valid) => {
                if (valid) {
                    let flag = false
                    let product_list = JSON.parse(JSON.stringify(this.formData.productData))
                    let post_product_list = []
                    product_list.forEach((item,index) => {
                        delete item.audit_num
                        delete item.stock_list
                        delete item.stock_info
                        item.no_code_num = item.no_code_num ? item.no_code_num : 0
                        if(item.code_list && item.code_list.length>0){
                            this.$set(item, 'code_list', item.code_list.map(codeItem => codeItem.code));
                        }
                        if(item.total_num && !item.stock_id && !flag){
                            this.$message.error(`请选择${item.name}出库仓库`)
                            flag = true
                        }
                        if(item.total_num){
                            post_product_list.push(item)
                        }
                    })
                    if(flag){return  false}
                    if(post_product_list.length == 0){return this.$message.error('请至少出库一个产品')}
                    let postData = {
                        product_list:post_product_list,
                        files:this.formData.file_list,
                        note:this.formData.note,
                        stock_pending_id:this.stock_pending_id,

                        stock_type:this.pending_info.stock_type,
                        approval_id:this.pending_info.approval_id,
                        approval_uid:this.pending_info.uid,
                        // approval_type:this.pending_info.approval_type,
                        // approval_set_id:this.pending_info.approval_set_id,
                        related_type:this.related_info.related_type,
                        related_id:this.related_info.related_id,
                        related_num:this.related_info.related_num,
                    }
                    const h = this.$createElement;
                    this.$msgbox({
                        title: '提交出库',
                        message: h('div', null, [
                            h('span', null, '确定执行出库操作吗？ \r\n 提交后无法撤回，请谨慎操作。'),
                        ]),
                        iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                        customClass: 'prompt_message_custom',
                        confirmButtonText:  '确定',
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                        showCancelButton: true,
                        confirmButtonClass:  'el-button--primary',
                        beforeClose: (action, instance, done) => {
                            if (action === 'confirm') {
                                done();
                            } else {
                                done();
                            }
                        }
                    }).then(() => {
                        this.btnDisabled = true
                        pendingOut(postData).then(res => {
                            if (res.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message:'出库成功',
                                    duration: 1500,
                                    onClose: () => {
                                        EventBus.$emit('inventoryOutUpdated');
                                        removeTag(this.$route)
                                        this.$router.go(-1);
                                        this.btnDisabled = false
                                    }
                                })
                            }else{
                                this.btnDisabled = false
                            }
                        })
                    }).catch(() => {
                    })

                }
            })
        },

        // 关联详情
        handleClickRelatedDetail(row){
            if(this.pending_info.related_type == 'purchase_return'){
                this.purchaseDetailVisible = true
            }else if(this.pending_info.biz_type == 'order'){
                this.$router.push({
                    name: "OrderDetail",
                    params: {
                        isPush: true,
                    },
                    query: {
                        order_id:this.related_info.related_id,
                        name:this.related_info.related_num,
                    },
                });
            }
        },
    },
}
</script>

<style lang="scss" scoped >

@import "@/styles/inventory_management.scss";
.bundle_wrap{
    width: 100%;
    h5{
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
        font-size: 14px;
        font-weight: bold;
        padding-bottom: 4px;
        border-bottom: 1px solid rgba(232, 232, 232, 1);
        margin-bottom: 4px;
    }
    p{
        line-height: 18px;
        font-size: 12px;
        color: rgba(102, 102, 102, 1);
    }
}
</style>